import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class AddonService {

  constructor(private http: HttpClient) { }

  saveAddons(id: any, payload: any){
    if(id){
      return this.http.patch(urls.API_URL + urls.ADDONS + `/${id}`, payload)
      .pipe(catchError(errorHandl));
    }
    return this.http.post(urls.API_URL + urls.ADDONS, payload)
      .pipe(catchError(errorHandl));
  }

  getAddons(queryParams? : any){
    const params = new HttpParams({fromObject : queryParams})
    return this.http.get(urls.API_URL + urls.ADDONS, {params})
     .pipe(catchError(errorHandl));
  }

  getPickerAddons(queryParams? : any){
    const params = new HttpParams({fromObject : queryParams})
    return this.http.get(urls.API_URL + urls.ADDONS + urls.PICKER, {params})
     .pipe(catchError(errorHandl));
  }

  getAddonById(id: any){
    return this.http.get(urls.API_URL + urls.ADDONS + `/${id}`)
    .pipe(catchError(errorHandl));
  }
}
